import React from "react";
import PropTypes from "prop-types";
import DeleteIcon from "@material-ui/icons/Delete";
import A_SimpleDialog from "../../../Atoms/Feedback/Dialogs/A_SimpleDialog.jsx";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button.jsx";

/**
 * Shared confirm/info dialog for the Provision card's delete flows (delete DCF file, etc.) —
 * one component instead of a bespoke window.confirm-style dialog per call site. Mirrors
 * src/components/Factory/Molecules/Common/ProfessionalContacts/ConfirmDialog.jsx, kept as its
 * own local copy so this card stays a genuinely self-contained unit (see Provision.styles.js).
 */
const ConfirmDialog = ({ open, mode, title, message, confirmLabel, onConfirm, onClose }) => {
  const isInfo = mode === "info";
  return (
    <A_SimpleDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="xs"
      dialogContent={message}
      dialogActions={
        isInfo ? (
          <A_Button label="OK" premiumVariant="primary" onClick={onClose} />
        ) : (
          <>
            <A_Button label="Cancel" onClick={onClose} />
            <A_Button
              label={confirmLabel}
              startIcon={<DeleteIcon fontSize="small" />}
              style={{ backgroundColor: "var(--color-error-main, #d32f2f)", color: "#fff" }}
              onClick={onConfirm}
            />
          </>
        )
      }
    />
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  mode: PropTypes.oneOf(["confirm", "info"]),
  title: PropTypes.string,
  message: PropTypes.node,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  open: false,
  mode: "confirm",
  title: "",
  confirmLabel: "Delete",
};

export default ConfirmDialog;
